import { Font, Text, View } from '@react-pdf/renderer';
import { Kitchen } from '@rta/rta-blueprint-library';

import { fontConfig } from '../font-config';
import { formatPrice } from '../../../helpers';
import { styleSheet } from '../style-sheet';

Font.register(fontConfig);

export type EstimateItemizedProps = {
	data: {
		kitchen: Kitchen;
		tax: number;
	};
}
// Create Document Component
export const EstimateItemized = (data: EstimateItemizedProps) => {
	const { kitchen, tax } = data.data;
	const { subtotal } = kitchen.itemizedMsrp;

	const total = subtotal + (tax ?? 0);
	const kitchenTax = tax ?? 'TBD';
	const formattedTotal = formatPrice(total);

	return (<>
		<View style={styleSheet.container}>
			<View style={styleSheet.quoteTotal}>
				<Text style={styleSheet.quoteTotalLabel}>Total</Text>
				<Text style={styleSheet.quoteTotalValue}>{formattedTotal}</Text>
			</View>
		</View>
		<View style={styleSheet.tableContainer}>
			<View style={styleSheet.tableHeaderRow}>
				<Text style={[styleSheet.tableCellFirst]}>PRODUCTS & SERVICES</Text>
				<Text style={[styleSheet.tableCellSku]}>SKU</Text>
				<Text style={[styleSheet.tableCellDescription]}>DESCRIPTION</Text>
				<Text style={[styleSheet.tableColumnQty]}>QUANTITY</Text>
				<Text style={[styleSheet.tableCellPrice]}>PRICE</Text>
			</View>

			{/* Every row comes from the canonical shared builder — identical to the panel and design package */}
			{kitchen.estimateLineItems.map((row, index) => (
				<View style={styleSheet.tableRowNoGap} key={`${row.sku}-${index}`}>
					<View style={styleSheet.tableCellFirst}>
						{row.kind === 'promo'
							? (<>
								<Text style={styleSheet.safeText}>{row.sku}</Text>
								<Text style={styleSheet.safeText}>{row.label}</Text>
							</>)
							: <Text>{row.label}</Text>}
						{row.discontinued && <Text style={{ color: '#C53030' }}>DISCONTINUED</Text>}
					</View>
					<Text style={styleSheet.tableCellSku}>{row.sku}</Text>
					<Text style={styleSheet.tableCellDescription}>{row.description}</Text>
					<Text style={styleSheet.tableColumnQty}>{row.qty}</Text>
					<Text style={styleSheet.tableCellPrice}>
						{formatPrice(row.price)}
						{row.priceNote && (
							<Text style={styleSheet.safeDiscountNotice}>
								{' after'} {row.priceNote} {'discount'}
							</Text>
						)}
					</Text>
				</View>
			))}
		</View>

		{/* Summary Section */}
		<View style={styleSheet.summarySection}>
			<View style={styleSheet.tableHeaderRow}>
				<Text style={[styleSheet.summaryCellFirst]}>SUMMARY</Text>
				<Text style={[styleSheet.tableColumnTotal]}></Text>
			</View>
			<View style={styleSheet.tableRowNoGap}>
				<View style={[styleSheet.flex]}>
					<Text style={styleSheet.summaryCellFirst}>One-time subtotal</Text>
					<Text style={styleSheet.tableColumnTotal}>{formatPrice(subtotal)}</Text>
				</View>
			</View>
			<View style={styleSheet.tableRowNoGap}>
				<View style={[styleSheet.flex]}>
					<Text style={styleSheet.summaryCellFirst}>Tax</Text>
					<Text style={styleSheet.tableColumnTotal}>{typeof kitchenTax === 'number' ? formatPrice(kitchenTax) : kitchenTax}</Text>
				</View>
			</View>
			</View>

		<View style={styleSheet.totalContainer}>
			<Text style={styleSheet.totalLabel}>Total:</Text>
			<Text style={styleSheet.totalValue}>{formatPrice(total)}</Text>
		</View>
	</>);
};
